import { Typography } from "@mui/material";
import { isRouteErrorResponse, Link, useRouteError } from "react-router";
import { useRouterSettings } from "src/routerSettings";

import { MainLayoutContainer } from "./layout/main/components/MainLayoutContainer";

export function ErrorPage() {
  const error = useRouteError();
  const routerSettings = useRouterSettings();

  let errorMessage = "";
  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  }

  return (
    <MainLayoutContainer sx={{ paddingTop: 8, textAlign: "center" }}>
      <Typography variant="h1">No toto?!</Typography>
      <Typography marginTop={4} variant="body1">
        To se ještě nikdy nestalo, ale v aplikaci došlo k nečekané chybě!
      </Typography>
      <Typography marginTop={4} variant="body1">
        {errorMessage}
      </Typography>
      <Typography marginTop={4} variant="body1">
        <Link to={routerSettings.defaultRoute}>Zpět na úvodní stránku</Link>
      </Typography>
    </MainLayoutContainer>
  );
}
